import { Form, Input, ModalProps, FormProps, Modal, InputNumber, Select, useSelect, message } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { findProjectFieldName } from 'gql/query'

import { ISubTheme } from 'interfaces'

type EditTopicProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const EditTopic: React.FC<EditTopicProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()
  const { selectProps: subThemeSelectProps } = useSelect<ISubTheme>({
    resource: 'sub_themes',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    filters: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {
    if (values && values?.name?.trim() && values?.sub_theme_id) {
      values.name = values?.name?.trim()
      const isNameStillSame = values?.name === formProps?.initialValues?.name
      if (!isNameStillSame) {
        const isNameRepeated: any = await findProjectFieldName(values.name, 'name', 'topics')
        if (isNameRepeated && isNameRepeated?.topics?.length > 0) {
          message.error('Topic name is already present... please make sure topics are unique')
          return false
        }
      }
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          updated_by: user?.id,
        })
      )
    } else {
      message.error('Expected values are missing...')
    }
  }
  return (
    <Modal {...modalProps} title="Edit Topic">
      <Form
        {...formProps}
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            if (response) {
              createUserHistory('topics', 'edit', response?.data?.id, user?.id, userRole)
            }
          })

          return response
        }}
      >
        <Form.Item
          label="Topic"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Sub Theme" name="sub_theme_id" rules={[{ required: true }]}>
          <Select {...subThemeSelectProps} />
        </Form.Item>
        <Form.Item name="updated_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
